"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTQueryFactoryFromJS = exports.RESTQueryFactory = void 0;
const immutable_1 = require("immutable");
const bases_1 = require("../bases");
const IREST_1 = require("../properties/IREST");
const structure_1 = require("../structure");
exports.RESTQueryFactory = (0, immutable_1.Record)(Object.assign(Object.assign({}, (0, bases_1.QueryFactory)().toJS()), { resultData: '', connectionType: 5 /* EConnectionTypes.REST */, properties: (0, IREST_1.RESTQueryPropertiesFactory)(), structure: (0, structure_1.RESTQueryReturnStructureFactory)() }));
const RESTQueryFactoryFromJS = function (data) {
    return (0, exports.RESTQueryFactory)(Object.assign(Object.assign({}, (0, bases_1.QueryFactoryFromJS)(data).toJS()), { properties: (0, IREST_1.RESTQueryPropertiesFactoryFromJS)(data.properties || {}), structure: (0, structure_1.RESTQueryReturnStructureFactoryFromJS)(data.structure) }));
};
exports.RESTQueryFactoryFromJS = RESTQueryFactoryFromJS;
//# sourceMappingURL=IRESTQuery.js.map